import React from "react";
import "./HomeText.css";
import Footer from "../footer/Footer";

export default function HomeText() {
    return (
        <div className="home-text-container">
            <h1>Let's play with pi.</h1>
            <h2>Sign up for free 22 hours of access.</h2>
            <h3>Play with pi.</h3>
            <p>
                Have a play with pi dashboard in our pre-configured environment and get to grips with how we work and the potential of our solution. It’s fully set-up and styled so you can see for yourself just how much we can re-brand and customise it for you. It’s yours for 22 hours so make the most out of it.
            </p>
            <div className="end-line">And don’t worry, you can’t break us!</div>
            <Footer/>
        </div>
    )

}